/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MedicaidCaseListPreset = {
    NeedsAction: 'needs_action',
    AssignedToMe: 'assigned_to_me',
    Closed: 'closed',
    All: 'all',
} as const;
export type MedicaidCaseListPreset = typeof MedicaidCaseListPreset[keyof typeof MedicaidCaseListPreset];


export function instanceOfMedicaidCaseListPreset(value: any): boolean {
    for (const key in MedicaidCaseListPreset) {
        if (Object.prototype.hasOwnProperty.call(MedicaidCaseListPreset, key)) {
            if (MedicaidCaseListPreset[key as keyof typeof MedicaidCaseListPreset] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MedicaidCaseListPresetFromJSON(json: any): MedicaidCaseListPreset {
    return MedicaidCaseListPresetFromJSONTyped(json, false);
}

export function MedicaidCaseListPresetFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicaidCaseListPreset {
    return json as MedicaidCaseListPreset;
}

export function MedicaidCaseListPresetToJSON(value?: MedicaidCaseListPreset | null): any {
    return value as any;
}

export function MedicaidCaseListPresetToJSONTyped(value: any, ignoreDiscriminator: boolean): MedicaidCaseListPreset {
    return value as MedicaidCaseListPreset;
}

